import { env, getHostConfig } from "@/constants/digitalHuman";
import axios from "@/utils/request/instance";
import { VadServiceMonitor } from '@/utils/vad';

export const getASRCorrect = (data: {
  mentorId: string | number;
  text: string;
}) => {
  return axios({
    method: "post",
    url: `${getHostConfig().host}/api/algo/asr/correct`,
    data: {
      appId: `digital-human-web-${env}`,
      id: data.mentorId,
      query: data.text
    }
  });
};

// 一体机 vad 服务
export function requestVadService(params: { mentorId: string, audioBuffer: ArrayBuffer[]}) {
  return axios({
    method: "post",
    url: `${getHostConfig().host}/api/qaRobot/new/vad?mentorId=${params.mentorId}`,
    headers: { "Content-Type": "application/octet-stream" },
    data: params.audioBuffer
  });
}

// 一体机 vad 服务
// VAD 语音活动检测服务
export function requestLocalVadService(params: {
  mentorId: string,
  audioBuffer: ArrayBuffer[],
  pThresh?: number,  // 音频有效性概率阈值
  rThresh?: number   // 有效音频时长占比阈值
}) {
  return axios({
    method: "post",
    url: "http://localhost:7770/vad",  // 使用你电脑的局域网 IP
    headers: { "Content-Type": "application/octet-stream" },
    data: params.audioBuffer
  });
}

// 统一的 VAD 服务接口
export async function requestUnifiedVadService(params: {
  mentorId: string,
  audioBuffer: ArrayBuffer[],
  pThresh?: number,
  rThresh?: number,
  text?: string,
  timeId?: number
}) {
  try {
    if (!VadServiceMonitor.getInstance().isAvailable()) {
      throw new Error('本地 VAD 服务不可用');
    }

    const localResponse = await requestLocalVadService({
      mentorId: params.mentorId,
      audioBuffer: params.audioBuffer,
    });
    if (!localResponse || localResponse.status !== 200) {
      throw new Error('Local VAD service response invalid');
    }
    localResponse.data.serviceType = 'local';
    return localResponse;
  } catch (error) {
    console.error('error', error);

    const res = await requestVadService({
      mentorId: params.mentorId,
      audioBuffer: params.audioBuffer
    });

    res.data.serviceType = 'cloud';
    return res;
  }
}

export function getMentorList(params: {
  mentorId?: string;
  noCache?: boolean;
}) {
  return axios({
    method: "post",
    url: `${getHostConfig().host}/api/mentor/list`,
    data: params
  });
}